import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { SERVICES } from "@/lib/constants";
import { useContent } from "@/lib/content";
import { useReveal } from "@/hooks/use-reveal";
import { HOME_IDS } from "@/constants/testIds/site";

export default function ServicesGrid() {
  const r = useReveal();
  const content = useContent();
  const services = (content?.services && content.services.length > 0) ? content.services : SERVICES;
  return (
    <section id="services" className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={r.ref} className={r.className}>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
            <div className="max-w-2xl">
              <span className="text-sm font-semibold uppercase tracking-widest text-[#0E7490]">Our Services</span>
              <h2 className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
                Everything for your <span className="text-[#0057B8]">FASTag journey</span>
              </h2>
              <p className="mt-4 text-[#6B7280] text-base sm:text-lg">
                From issuance to recharge and replacement — we make FASTag simple, fast and friendly.
              </p>
            </div>
            <Link to="/order" className="text-[#0057B8] font-semibold hover:text-[#003F87] inline-flex items-center gap-2" data-testid="services-order-link">
              Order Now <Icons.ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => {
              const Ic = Icons[s.icon] || Icons.Sparkles;
              return (
                <div
                  key={s.key}
                  data-testid={`${HOME_IDS.serviceCard}-${s.key}`}
                  className="group relative bg-white rounded-2xl border border-[#E2E8F0] p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-transform transition-shadow duration-300"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#0057B8]/10 text-[#0057B8] grid place-items-center mb-5 group-hover:bg-[#0057B8] group-hover:text-white transition-colors duration-300">
                    <Ic className="w-6 h-6" />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-[#111827]">{s.title}</h3>
                  <p className="mt-2 text-[#6B7280] leading-relaxed">{s.desc}</p>
                  <div className="mt-5 flex items-center gap-2 text-sm font-semibold text-[#0E7490]">
                    <span>Learn how it works</span>
                    <Icons.ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
                  </div>
                  <div className="absolute inset-x-6 -bottom-px h-px bg-gradient-to-r from-transparent via-[#F59E0B] to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
